import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import { useEffect, useState } from 'react';
import EFPicture from '@elem/compCommon/EFPicture';
import { getIsPadWidth } from '@elem/utils/devices';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

export default function RealStory() {
    const { t } = useLang('communitylang.realStory');
    const { Link } = useGlobal();
    const [gap, setGap] = useState(16);
    const [activeTab, setActiveTab] = useState(0);
    const [swiper, setSwiper] = useState(null);
    const [winW, setWinW] = useState(390);
    const tabs = ['Power Backup', 'Lifestyle', 'Off-Grid'];
    const isMobile = getIsPadWidth(); //是否是移动端

    const tabsMap: any = {
        0: [
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718681828171/community_c1_1.png',
                title: t('tab1_1_name'),
                desc: t('tab1_1_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/posts/1830612767405570/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718681828346/community_c1_2.png',
                title: t('tab1_2_name'),
                desc: t('tab1_2_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/posts/1818137978653049/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718696354651/community_c1_3.png',
                title: t('tab1_3_name'),
                desc: t('tab1_3_desc'),
                link: 'https://www.facebook.com/groups/ecoflowclub/posts/1732963990529006/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718681828530/community_c1_4.png',
                title: t('tab1_4_name'),
                desc: t('tab1_4_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/posts/1830926520707528/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718681828704/community_c1_5.png',
                title: t('tab1_5_name'),
                desc: t('tab1_5_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/posts/1757609654705882/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718681828883/community_c1_6.png',
                title: t('tab1_6_name'),
                desc: t('tab1_6_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/permalink/1745295622603952/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718681829064/community_c1_7.png',
                title: t('tab1_7_name'),
                desc: t('tab1_7_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/posts/1745082395958608/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718681829240/community_c1_8.png',
                title: t('tab1_8_name'),
                desc: t('tab1_8_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/posts/1719890121811169/',
            },
        ],
        1: [
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682038606/community_c2_1.png',
                title: t('tab2_1_name'),
                desc: t('tab2_1_desc'),
                link: 'https://www.facebook.com/groups/ecoflowclub/posts/1282709008887842/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682038786/community_c2_2.png',
                title: t('tab2_2_name'),
                desc: t('tab2_2_desc'),
                link: 'https://www.facebook.com/groups/ecoflowclub/posts/1712553049236767/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682038958/community_c2_3.png',
                title: t('tab2_3_name'),
                desc: t('tab2_3_desc'),
                link: 'https://www.facebook.com/groups/ecoflowclub/posts/1754362978389107/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719219166181/community_c2_4.jpg',
                title: t('tab2_4_name'),
                desc: t('tab2_4_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/posts/1345901599210025/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682039309/community_c2_5.png',
                title: t('tab2_5_name'),
                desc: t('tab2_5_desc'),
                link: 'https://www.facebook.com/groups/ecoflowclub/posts/1753842005107871/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682039472/community_c2_6.png',
                title: t('tab2_6_name'),
                desc: t('tab2_6_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/permalink/1824068948059952/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682039639/community_c2_7.png',
                title: t('tab2_7_name'),
                desc: t('tab2_7_desc'),
                link: 'https://www.facebook.com/groups/ecoflowclub/posts/1769979000160838/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682212307/community_c2_8.png',
                title: t('tab2_8_name'),
                desc: t('tab2_8_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/posts/1728066984326816/',
            },
        ],
        2: [
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682212476/community_c3_1.png',
                title: t('tab3_1_name'),
                desc: t('tab3_1_desc'),
                link: 'https://www.facebook.com/groups/ecoflowclub/posts/1770446643447407/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718702930357/community_c3_2.png',
                title: t('tab3_2_name'),
                desc: t('tab3_2_desc'),
                link: 'https://www.facebook.com/groups/ecoflowclub/posts/1744789992679739/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682212829/community_c3_3.png',
                title: t('tab3_3_name'),
                desc: t('tab3_3_desc'),
                link: 'https://www.facebook.com/groups/ecoflowclub/posts/1743011739524231/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682213004/community_c3_4.png',
                title: t('tab3_4_name'),
                desc: t('tab3_4_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/posts/1703532080113640/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682213178/community_c3_5.png',
                title: t('tab3_5_name'),
                desc: t('tab3_5_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/posts/1707738186359696/',
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718682213355/community_c3_6.png',
                title: t('tab3_6_name'),
                desc: t('tab3_6_desc'),
                link: 'https://www.facebook.com/groups/deltaprolaunch/posts/1748297458970435/',
            },
        ],
    };

    const [cards, setCards] = useState(tabsMap[0]);

    const clickTab = (key: number) => {
        swiper?.slideTo(0);
        scrollBar(key);
        if (key !== activeTab) {
            setActiveTab(key);
            setCards(tabsMap[key]);
        }
    };

    const OFFSET_MAP: any = {
        0: 0,
        1: (540 - winW) / 2,
        2: 540 - winW,
    };
    const scrollBar = (key: number) => {
        const wrapper = document.querySelector<HTMLDivElement>('#community-page-C .scroll');
        if (!wrapper || !isMobile) return;
        wrapper.scrollTo({
            left: OFFSET_MAP[key],
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        const innerWidth = window?.innerWidth;
        setWinW(innerWidth);
        setGap(innerWidth > 1440 ? 24 : 16);
    }, []);

    return (
        <div id="community-page-C" className={`real-story ${css.realStory}`}>
            <p className="story-title">{t('title')}</p>
            <p className="story-desc">{t('desc')}</p>
            <div className="scroll hidden-scrollbar">
                <div className="tab-btns">
                    {tabs.map((item, index) => (
                        <p key={index} className={`tab-item ${index === activeTab ? 'active-tab' : ''}`} onClick={() => clickTab(index)}>
                            {item}
                        </p>
                    ))}
                </div>
            </div>
            <Swiper
                modules={[Navigation, Pagination]}
                pagination={{
                    clickable: true,
                }}
                navigation
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                onSwiper={(swiperIns: any) => setSwiper(swiperIns)}
            >
                {!isMobile && (
                    <>
                        <SwiperSlide>
                            {cards.slice(0, 4).map((item, index) => (
                                <div className="card-box" key={index}>
                                    <div className="img-box">
                                        <EFPicture src={item.img} srcPad={item.img} srcMobile={item.img} />
                                    </div>
                                    <p className="item-title">{item.title}</p>
                                    <p className="item-desc">{item.desc}</p>
                                    <Link
                                        className="item-link"
                                        href={item.link}
                                        ariaLabel={t('join')}
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'community_button',
                                            list_name: t('title'),
                                            button_name: t('learn_more'),
                                        }}
                                    >
                                        {t('learn_more')}
                                    </Link>
                                </div>
                            ))}
                        </SwiperSlide>
                        <SwiperSlide>
                            {cards.map((item, index) => {
                                if (index < 4) {
                                    return <></>;
                                }
                                return (
                                    <div className="card-box" key={index}>
                                        <div className="img-box">
                                            <EFPicture src={item.img} srcPad={item.img} srcMobile={item.img} />
                                        </div>
                                        <p className="item-title">{item.title}</p>
                                        <p className="item-desc">{item.desc}</p>
                                        <Link
                                            className="item-link"
                                            href={item.link}
                                            ariaLabel={t('join')}
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'community_button',
                                                list_name: t('title'),
                                                button_name: t('learn_more'),
                                            }}
                                        >
                                            {t('learn_more')}
                                        </Link>
                                    </div>
                                );
                            })}
                        </SwiperSlide>
                    </>
                )}
                {isMobile &&
                    cards.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="card-box">
                                <div className="img-box">
                                    <EFPicture src={item.img} srcPad={item.img} srcMobile={item.img} />
                                </div>
                                <p className="item-title">{item.title}</p>
                                <p className="item-desc">{item.desc}</p>
                                <Link
                                    className="item-link"
                                    href={item.link}
                                    ariaLabel={t('join')}
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'community_button',
                                        list_name: t('title'),
                                        button_name: t('learn_more'),
                                    }}
                                >
                                    {t('learn_more')}
                                </Link>
                            </div>
                        </SwiperSlide>
                    ))}
            </Swiper>
        </div>
    );
}
